import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import HomeworkVideoComponent from './HomeworkVideoComponent';
import HmEventRegistry from '../../model/HmEventRegistry';

// ES6 class-style
class HomeworkBannerBuy extends PreLoginPage {
	constructor(props) {
		super(props);
	}

	componentDidMount(){
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	}

    onClickDemoFn = () => {
        if(typeof this.props.demoFn === "function"){
			this.props.demoFn();
		}
    }
	
	getDemoBtn(){
		return (
            <div className='col-md-12 mb-10 demobtn'>		
            <span data-ga="Homework - Likedemo" onClick={this.onClickDemoFn} className="r-btn contactbtn">{this.rb("homework.demo")}</span>		  					  		
				  	</div>
        );
	}

  render() {
  	return(
			  <section className={this.props.classes+" tchrhead homeworkhead"} >
		  <div className="clearfix"></div>
  		<div className="container"> 
		  <div>
			<h1>{this.rb("homework.title")}</h1>   
			<h1>{ReactHtmlParser(this.rb("homework.title1"))}</h1>  
			
			<HomeworkVideoComponent></HomeworkVideoComponent>
            {this.getDemoBtn()} 
		  </div>
  		</div> 
  		</section>
  		);
  	}
  }

  export default HomeworkBannerBuy;


// WEBPACK FOOTER //
// ./src/vendors/homework/HomeworkBannerBuy.js